// extracted by mini-css-extract-plugin
export default {"bank-report-container":"bank_bank-report-container__WvcSa"};